import { arrayOf, func, object } from 'prop-types';
import React from 'react';
import { path } from 'ramda';

import ActionButton from 'components/ActionButton';
import ContentColumns from '../components/ContentColumns';

import View1 from './Views/View1';
import View2 from './Views/View2';
import View8 from './Views/View8';
import View9 from './Views/View9';

class Rehabilitation5 extends React.Component {
  state = {
    view: 1,
  };

  componentDidMount() {
    const finished = path(['formValues', 'rehab5', 'finished'], this.context);
    // If this session is finished, navigate to last view
    if (finished) this.setState({ view: 9 });
  }

  advanceView = () => {
    const { setFinished } = this.context;
    if (this.state.view === 8) {
      setFinished();
    }
    this.setState({ view: this.state.view + 1 });
  };

  backView = () => {
    this.setState({ view: this.state.view - 1 });
  };

  render() {
    const { view } = this.state;
    return (
      <div>
        {view === 1 ? (
          <View1 documents={this.props.documents} />
        ) : view > 1 && view < 8 ? (
          <View2 viewIndex={view} />
        ) : view === 8 ? (
          <View8 />
        ) : view === 9 ? (
          <View9 documents={this.props.documents} />
        ) : null}
        <ContentColumns
          firstColumn={
            <div style={{ display: 'flex', marginTop: '2rem' }}>
              <div style={{ flex: 1 }}>
                {view > 1 ? (
                  <ActionButton
                    localeId={'onlineRehabilitation.back'}
                    onClick={this.backView}
                    style={{ width: '15rem' }}
                    secondary
                  />
                ) : null}
              </div>
              {view !== 9 && (
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                  <ActionButton
                    localeId={view === 8 ? 'onlineRehabilitation.send' : 'onlineRehabilitation.advance'}
                    onClick={this.advanceView}
                    style={{ width: '15rem' }}
                    filledSecondary
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

Rehabilitation5.contextTypes = { setFinished: func, formValues: object };
Rehabilitation5.propTypes = { documents: arrayOf(object) };

export default Rehabilitation5;
